export interface CreateCampaignUserRequest {
  landingpage: string;
  lpn: string;
  email?: string;
  phoneNumber?: string;
  phonePrefix?: string;
  password?: string;
  consent: boolean;
  source: string;
  first_termination: string;
  product: string | null;
}

export interface CreateCampaignUserResponse {
  token?: string;
  wallet: string;
  membership: string;
}

export interface LandingPageDiscountData {
  first_month_free: boolean;
  free_registration: boolean;
  free_atav: boolean;
  product: number; // Assuming 'product' is a product ID or similar identifier
}

export interface LandingPageProductData {
  uid: string;
  name: string;
  price: number;
  discount: LandingPageDiscountData;
  registration_fee: number;
  atav: number;
  plan_id: string;
}

export interface LandingpageProductResponse {
  name: string;
  content: CampaignHeroContent;
  image: string;
  discount: LandingPageDiscountData;
  discount_period: DiscountPeriod;
  next_period: NextPaymentPeriod;
  first_cancel_date: string;
  plan_price: number;
  plan_name: string;
  first_payment: string;
  first_full_payment: string;
  first_termination: string;
  termination_rule: number;
  min_amount: number;
  discount_type: DiscountType;
  registration_fee: number;
  plan_price_rest_month: number;
}

export interface LandingPageNullProductResponse {
  name: string;
  content: CampaignHeroContent;
  products: LandingPageProductData[];
  image: string;
  show_product_selector: boolean; // Indicates if the product selector should be shown (Extra step placed before the user information step)
}

export interface LandingPageAPIPayload {
  landingpageId: string;
  product?: string | null;
}

export interface CampaignHeroContent {
  content: string; // HTML content represented as a string
  description: string;
  title: string;
  nextPayment: string;
  saveUpTo: string;
  additionalTerms: string;
  splashContent: {
    discount: string;
    price: string;
    freeRegistration: string;
  };
  button: string;
}

export interface DiscountPeriod {
  start: string;
  end: string;
}

export interface NextPaymentPeriod {
  start: string;
  end: string;
  price: 154.06;
}

export enum CampaignSteps {
  PRODUCT_SELECTION = 'product_selection',
  USER_INFORMATION = 'user_information',
  PAYMENT_INFORMATION = 'payment_information',
}

export enum TerminationRule {
  NORMAL_TERMINATION = 1,
  TERMINATION_LAST_DAY_OF_NEXT_MONTH = 2,
}

export enum DiscountType {
  FREE_MONTH = 2,
  HALV_PRICE_2_MONTHS = 4,
}

export interface CreateNewUserRequest {
  email: string;
  consent: number;
  identityProvider: string;
  phone: number;
  phone_prefix: string;
  password: string;
}

export interface ValidationSchemaProps {
  isAuthenticated: boolean;
  isSignUp?: boolean;
  phoneNumberPrefix: string;
  errorMessages: any;
}

export interface CampaignFormErrors {
  licensePlate?: string[] | undefined;
}

export interface RegisterCarResponse {
  cars_registered: string[];
}

export interface RegisterCarRequest {
  license_plate: string[];
  agreements: string | null;
}
